import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        meta: {
            activeRouteName: 'Home'
        },
        component: Home
    },
    // 其它页面使用按需加载的形式
    {
        path: '/introduction',
        name: 'Introduction',
        meta: {
            activeRouteName: 'Introduction'
        },
        component: () => import( '../views/introduction.vue')
    },
    {
        path: '/exhibition',
        name: 'Exhibition',
        meta: {
            activeRouteName: 'Exhibition'
        },
        component: () => import('../views/exhibition.vue')
    }, {
        path: '/exhibition-detail',
        name: 'ExhibitionDetail',
        meta: {
            title: '展馆展览详情',
            menuPath: '/exhibition',
            activeRouteName: 'Exhibition'
        },
        component: () => import('../views/exhibitionDetail.vue')
    }, {
        path: '/information',
        name: 'Information',
        meta: {
            title: '资讯',
            activeRouteName: 'Information'
        },
        component: () => import('../views/information.vue')
    }, 
    {
        path: '/academic',
        name: 'Academic',
        meta: {
            title: '学术',
            activeRouteName: 'Academic'
        },
        component: () => import('../views/academic.vue')
    }, {
        path: '/information/detail',
        name: 'InformationDetail',
        meta: {
            title: '资讯详情',
            menuPath: '/information'
        },
        component: () => import('../views/informationDetail.vue')
    }, {
        path: '/academic/detail',
        name: 'AcademicDetail',
        meta: {
            title: '学术详情',
            menuPath: '/academic',
            activeRouteName: 'Academic'
        },
        component: () => import('../views/informationDetail.vue')
    },
    {
        path: '/cultural-relics',
        name: 'CulturalRelics',
        meta: {
            activeRouteName: 'CulturalRelics'
        },
        component: () => import('../views/culturalRelics.vue')
    },
    {
        path: '/cultural-relics/detail',
        name: 'CulturalRelicsDetail',
        meta: {
            menuPath: '/cultural-relics',
            activeRouteName: 'CulturalRelics'
        },
        component: () => import('../views/culturalRelicsDetail.vue')
    }, {
        path: '/cultural-creative',
        name: 'CulturalCreative',
        meta: {
            activeRouteName: 'CulturalCreative'
        },
        component: () => import('../views/culturalCreative.vue')
    },
    {
        path: '/cultural-creative/detail',
        name: 'CulturalCreativeDetail',
        meta: {
            menuPath: '/cultural-creative',
            activeRouteName: 'CulturalCreative'
        },
        component: () => import('../views/culturalCreativeDetail.vue')
    }, {
        path: '/intangible-cultural',
        name: 'intangibleCultural',
        component: () => import('../views/intangibleCultural.vue')
    },
    {
        path: '/intangible-cultural/detail',
        name: 'intangibleCulturalDetail',
        meta: {
            menuPath: '/cultural-creative',
            activeRouteName: 'CulturalCreative'
        },
        component: () => import('../views/intangibleCulturalDetail.vue')
    },
    {
        path: '/new-article-details',
        name: 'newArticleDetails',
        component: () => import('../views/newArticleDetails.vue')
    },
    {
        path: '/luiyan',
        name: 'luiyan',
        meta: {
            activeRouteName: 'Forum'
        },
        component: () => import('../views/luiyan.vue')
    },
    {
        path: '/questionnaire',
        name: 'Questionnaire',
        meta: {
            title: '问卷调查',
            activeRouteName: 'Forum'
        },
        component: () => import('../views/questionnaire.vue')
    },
    {
        path: '/articleSearch',
        name: 'articleSearch',
        component: () => import('../views/articleSearch.vue')
    },
    {
        path: '/volunteer-registration',
        name: 'VolunteerRegistration',
        meta: {
            title: '志愿者报名'
        },
        component: () => import('../views/volunteerRegistration.vue')
    },
    {
        path: '/exhibition-extra',
        name: 'exhibitionExtra',
        component: () => import('../views/exhibitionExtra.vue')
    }
];

const router = new VueRouter({
    routes,
    scrollBehavior (to, from, savedPosition) {
        // 如果有savedPosition，就用它，没有就会是{ x: 0, y: 0 }
        if (savedPosition) {
            return savedPosition;
        } 
        // 如果不想保存位置，可以返回falsy值，比如false或者null
        return { x: 0, y: 0 };
        
    }
});

export default router;
